import React from 'react';
import {
    ArrowTrendingUpIcon,
    ExclamationTriangleIcon,
    UserGroupIcon,
    CloudIcon,
} from '@heroicons/react/24/outline';
import lineMovement from '@assets/images/screenshots/Linemovement.png';
import injuryReports from '@assets/images/screenshots/InjuryReports.png';
import lineups from '@assets/images/screenshots/Lineups.png';
import weatherConditions from '@assets/images/screenshots/WeatherConditions.png';

const features = [
    {
        name: 'Line Movement',
        description: 'Track spread, moneyline, and totals across game periods from multiple sportsbooks. See real-time line movements with historical charts to identify sharp money and find the best value.',
        icon: ArrowTrendingUpIcon,
        image: lineMovement,
    },
    {
        name: 'Injury Reports',
        description: 'Stay updated with real-time injury status for both teams. Get immediate notifications on player availability and understand the impact on game outcomes.',
        icon: ExclamationTriangleIcon,
        image: injuryReports,
    },
    {
        name: 'Starting Lineups',
        description: 'View confirmed starting lineups with detailed player statistics. Know who\'s on the court or field before you place your bets.',
        icon: UserGroupIcon,
        image: lineups,
    },
    {
        name: 'Weather Conditions',
        description: 'Access game-day weather data for outdoor sports. Temperature, wind speed, precipitation forecasts, and more to factor into your betting decisions.',
        icon: CloudIcon,
        image: weatherConditions,
    },
];

export const BettingIntelligenceFeature = () => {
    return (
        <div className="bg-gray-50 dark:bg-brand-dark-800 py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-base/7 font-semibold text-brand-red-500 dark:text-brand-red-400">Betting Intelligence</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl sm:text-balance">
                        Everything You Need to Bet Smart
                    </p>
                    <p className="mt-6 text-lg/8 text-gray-600 dark:text-gray-400">
                        Get real-time betting lines, injury updates, confirmed lineups, and weather conditions all in one place. 
                        Make informed decisions with the most up-to-date information available.
                    </p>
                </div>
                
                <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:gap-8">
                    {features.map((feature) => (
                        <div key={feature.name} className="flex flex-col gap-4 rounded-2xl bg-white p-6 ring-1 ring-inset ring-gray-200 dark:bg-brand-dark-900 dark:ring-gray-700">
                            <div className="flex items-center gap-x-3">
                                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-red-500">
                                    <feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
                                </div>
                                <h3 className="text-lg font-semibold leading-8 tracking-tight text-gray-900 dark:text-white">
                                    {feature.name}
                                </h3>
                            </div>
                            <div className="overflow-hidden rounded-lg">
                                <img 
                                    src={feature.image} 
                                    alt={`${feature.name} interface`}
                                    className="w-full h-auto object-cover ring-1 ring-gray-900/10 dark:ring-white/10"
                                />
                            </div>
                            <p className="text-base leading-7 text-gray-600 dark:text-gray-400">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

